module.exports = __webpack_public_path__ + "static/logo_1-7e85eb386ec2f8c4d5e257d6c9002d0d.png";